// stores 
import * as PractitionerStore from '../../../../redux/middleware/PractitionerMiddleware';
import * as PractitionerConsumptionSyncProcessStore from '../../../../redux/middleware/PractitionerConsumptionSyncProcessMiddleware';
import * as PractitionerConsumptionStore from '../../../../redux/middleware/PractitionerConsumptionMiddleware';
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';
import * as ProtocolsStore from '../../../../redux/middleware/MedicalProtocolMiddleware';


// state
import { AppState } from '../../../../redux/reducers';

// models
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { PractitionerConsumptionSyncProcess } from '../../../../models/Entities/Practitioners/PractitionerConsumptionSyncProcess';
import { ErrorType } from '../../../../models/HttpError';
import { Practitioner } from '../../../../models/Entities/Practitioners/Practitioner';

//#region Props

interface IProps {
    PractitionerId: string;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    failureLoading: boolean;
    ErrorGetting: ErrorType | null;

    isAdding: boolean;
    successAdding: boolean;
    failureAdding: boolean;
    ErrorAdding: ErrorType | null;

    CurrentProcess: PractitionerConsumptionSyncProcess;
    practitioner: Practitioner | null;

    haveContractAssociated: boolean;
}

interface MedicalServicesDispatchProps {
    GetPractitionerById: typeof PractitionerStore.actionCreators.GetPractitionerById;
    GetLastPractitionerConsumptionSyncProcessByPractitionerId: typeof PractitionerConsumptionSyncProcessStore.ActionCreators.GetLastPractitionerConsumptionSyncProcessByPractitionerId;
    CreatePractitionerConsumptionSyncProcess: typeof PractitionerConsumptionSyncProcessStore.ActionCreators.CreatePractitionerConsumptionSyncProcess;
    UpdatePractitionerConsumptionSyncProcess: typeof PractitionerConsumptionSyncProcessStore.ActionCreators.UpdatePractitionerConsumptionSyncProcess
    GetAllPractitionerConsumptionsByPractitioner: typeof PractitionerConsumptionStore.ActionCreators.GetAllPractitionerConsumptionsByPractitioner;
    GetProtocolsByPractitionerId: typeof ProtocolsStore.actionCreators.GetProtocolsByPractitionerId;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const AuxPractitioner: Practitioner | null =  state.Practitioners?.list?.find((practitioner: Practitioner) => practitioner.userId === ownProps.PractitionerId) || null;

    return {
        isLoading: AuxPractitioner?.isLoadingLastConsumptionSyncProcess ?? false,
        successLoading: AuxPractitioner?.loadedLastConsumptionSyncProcessSuccessfully ?? false,
        failureLoading: AuxPractitioner?.failOnLoadLastConsumptionSyncProcess ?? false,
        ErrorGetting: AuxPractitioner?.errorOnLoadLastConsumptionSyncProcess ?? null,

        isAdding: AuxPractitioner?.isCreatingSyncProcess ?? false,
        successAdding: AuxPractitioner?.createdSyncProcessSuccessfully ?? false,
        failureAdding: AuxPractitioner?.failOnCreateSyncProcess ?? false,
        ErrorAdding: AuxPractitioner?.errorOnCreateSyncProcess ?? null,

        CurrentProcess: AuxPractitioner?.lastConsumptionSyncProcess ?? null,
        practitioner: AuxPractitioner,
        haveContractAssociated: (AuxPractitioner?.Protocols ?? []).length > 0 ? true : false
    };
};

export const mapDispatchToProps = {
    ...PractitionerStore.actionCreators,
    ...PractitionerConsumptionSyncProcessStore.ActionCreators,
    ...PractitionerConsumptionStore.ActionCreators,
    ...ContractStore.actionCreators,
    ...ProtocolsStore.actionCreators,
};